export default __webpack_public_path__ + "static/media/fclg.53eeef96.svg";